import { QuerySearchCondition } from '../interfaces/app/searchCondition';
import { AppQueryParams } from '../constants/queryParams';

/**
 * クエリパラメーター生成
 * @param param クエリパラメーター生成用データ
 * @returns {string} クエリパラメーター
 */
export const createParam = (param: QuerySearchCondition | AppQueryParams) => {
  return `?${Object.entries(param)
    .map((e) => (e[1] ? `${e[0]}=${e[1]}` : null))
    .filter((i) => i !== null)
    .join('&')}`;
};

/**
 * クエリパラメーター生成 空文字許容
 * @param param クエリパラメーター生成用データ
 * @returns {string} クエリパラメーター
 */
export function createParamEmptiable(param: Record<string, unknown>): string {
  return `?${Object.entries(param)
    .map((e) => `${e[0]}=${e[1] ?? ''}`)
    .join('&')}`;
}
